// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;Remember the marvels he has done,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;his wonders and the judgements of his mouth,<br> </p> </div></div>";
// Exports
module.exports = code;